export default function({ state, rootState, commit, dispatch }, id) {
    commit('startLoading')

    return dispatch('get', {
        url: '/provider/' + (id || state.id),
        query: {
            expand: true
        }
    }, {
        root: true
    })
    .then((provider) => {
        commit('finishLoading')
        if(provider.timezone && typeof provider.timezone === 'string')
            commit('addProviderTimezone', provider.timezone)
        commit('addFilter', {
            id,
            filter: provider.filter
        })
        if(provider.integration && provider.integration.push_chart)
            commit('addProviderPushIntegration', id)
        return provider
    })
    .catch((error) => {
        commit('finishLoading')
        console.log(error)
        throw error
    })
}
